import { For, Show } from "solid-js";
import { classesColorees } from "../domaine/graphe";
import { fondPastille } from "./analyse";
import type { Portefeuille } from "../domaine/types";

/**
 * Correspondance couleur ↔ bioagresseur, commune à toutes les vues de la donnée.
 * Au-delà de trois classes la couleur n'encode plus rien, et on le dit plutôt que
 * de le subir (ADR-0005 R4 du POC).
 */
export function Legende(props: { portefeuille: Portefeuille }) {
  const classes = () => props.portefeuille.classesBioagresseur;
  const colorees = () => classesColorees(classes());
  /** Un secteur par teinte en usage, comme le disque d'un projet multi-cible. */
  const secteurs = () => fondPastille(colorees().map((_, i) => `var(--cible-${i + 1})`));
  return (
    <Show when={classes().length}>
      <div class="legende">
        <Show
          when={colorees().length}
          fallback={
            <p class="note-legende">
              {classes().length} classes de bioagresseur : trop pour une palette lisible. La couleur
              n'encode plus rien. Les cibles sont dans la fiche de chaque projet.
            </p>
          }
        >
          <span class="intitule">Bioagresseur visé</span>
          <ul class="entrees" aria-label="Bioagresseur visé">
            <For each={colorees()}>
              {(c, i) => (
                <li class="entree">
                  <span class="pastille" style={{ background: `var(--cible-${i() + 1})` }} />
                  <span>{c.libelle}</span>
                </li>
              )}
            </For>
            <Show when={colorees().length > 1}>
              <li class="entree">
                <span class="pastille" style={{ background: secteurs() }} />
                <span>plusieurs cibles</span>
              </li>
            </Show>
          </ul>
        </Show>
      </div>
    </Show>
  );
}
